export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/63b0caf2-9ab6-4ee9-ad57-be8cf131013c/OtAutoBlock.js',
  domainScript: '63b0caf2-9ab6-4ee9-ad57-be8cf131013c',
};
